import { defineStore } from "pinia";
import { ref } from "vue";
import { pageStates } from "@/components/Buy/Payment/PaymentConfigs";
import { ICreditCardAddress } from "@/components/Buy/Interfaces";

export const usePaymentPageStore = defineStore("paymentPage", () => {
  const pageState = ref<pageStates>(pageStates.displayCards);
  const creditAddress = ref<ICreditCardAddress>();
  return {
    pageState,
    creditAddress,
  };
});
